// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/scroll-text.js';

import { paths } from '../generated/scroll-text';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('scroll-text', Original, paths);
